import ActivityTracker, { ActivityTrackerTrackProps } from "utils/tracker/ActivityTracker";
import { useLocation, useRouteMatch } from "react-router-dom";

import { isNullOrUndefOrEmpty } from "@civicscience/chops";
import { useEffect } from "react";

type UseActivityTrackerProps = Omit<ActivityTrackerTrackProps, "url" | "dateViewed" | "pageTitle"> & {
  title: string;
  subTitle?: string | null;
};

export const getActivityTrackerPageTitle = (title: string, subtitle: string | null = ""): string => {
  return `${title}${!isNullOrUndefOrEmpty(subtitle) ? ` - "${subtitle}"` : ""}`;
};

const useActivityTracker = ({ name, title, subTitle }: UseActivityTrackerProps): void => {
  const { search } = useLocation();
  const { url } = useRouteMatch();
  const pageTitle = getActivityTrackerPageTitle(title, subTitle);

  useEffect(() => {
    !isNullOrUndefOrEmpty(name) &&
      !isNullOrUndefOrEmpty(pageTitle) &&
      ActivityTracker.track({
        name,
        url: `${url}${search}`,
        pageTitle,
        dateViewed: Date.now(),
      });
  }, [url, search, name, pageTitle]);
};

export default useActivityTracker;
